import { NotFound } from '@/components/common';

const NotFoundPage = () => {
  return <NotFound />;
};

export default NotFoundPage;
